import { createContext, useContext } from 'react';
import type { Agency, Subaccount } from '../api';

export interface AgencyContextValue {
  agency: Agency;
  /** Active and suspended sub-accounts visible to the caller (archived excluded). */
  subaccounts: Subaccount[];
  reloadSubaccounts: () => void;
  /** Replace the agency after an edit (re-themes the app). */
  updateAgency: (agency: Agency) => void;
  isManager: boolean;
}

export const AgencyContext = createContext<AgencyContextValue | null>(null);

export function useAgency(): AgencyContextValue {
  const value = useContext(AgencyContext);
  if (!value) throw new Error('useAgency must be used inside an agency route');
  return value;
}
